const DashboardAT = {
  FETCH_DASHBOARD_REQUEST: 'FETCH_DASHBOARD_REQUEST',
  FETCH_DASHBOARD_SUCCESS: 'FETCH_DASHBOARD_SUCCESS',
  FETCH_DASHBOARD_FAILURE: 'FETCH_DASHBOARD_FAILURE',
} as const;

export default {
  ...DashboardAT,
};
